import { parseTime } from "@/utils";
export const timeRnage = {
  data() {
    return {
      pickerOptions_start: {
        disabledDate(time) {
          let org_start = localStorage.getItem("defaultStartMonth");
          let org_end = localStorage.getItem("defaultEndMonth");
          if (org_start != org_end) {
            //如果不加.replace(/-/g, "/") new Date出来的的日期是8点钟而不是0点
            if (time < new Date(org_start.replace(/-/g, "/"))) {
              return true;
            } else if (time > new Date(org_end.replace(/-/g, "/"))) {
              return true;
            } else {
              return false;
            }
          } else {
            if (
              time.getMonth() ==
              new Date(org_start.replace(/-/g, "/")).getMonth()
            ) {
              return false;
            } else {
              return true;
            }
          }
        },
      },
      pickerOptions_end: {
        disabledDate(time) {
          let org_start = localStorage.getItem("defaultStartMonth");
          let org_end = localStorage.getItem("defaultEndMonth");
          if (org_start != org_end) {
            if (time < new Date(org_start.replace(/-/g, "/"))) {
              return true;
            } else if (time > new Date(org_end)) {
              return true;
            } else {
              return false;
            }
          } else {
            if (time.getMonth() == new Date(org_start).getMonth()) {
              return false;
            } else {
              return true;
            }
          }
        },
      },
    };
  },
  methods: {},
};

export const listenObj = {
  data() {
    return {};
  },
  computed: {
    listenObj() {
      return {
        plat: this.$store.state.user.plants,
        kol_type: this.$store.state.user.kolType,
        brand_id: "",
        start: this.$store.state.user.startMonth,
        end: this.$store.state.user.endMonth,
        word: this.$store.state.user.selectedKeyWords,
        selected_type: this.$store.state.user.selectedType,
        kol_id: this.$store.state.user.KolId,
        kol_name: this.$store.state.user.KolName,
        cat_id: this.$store.state.user.catId,
        rule_id: this.$store.state.user.ruleId,
        cat_name: this.$store.state.user.catName,
        analyse_typ: this.$store.state.user.analyseTyp,
        r_rule_id: this.$store.state.user.routerRuleId,
        words: this.$store.state.user.words,
        r_analyse_typ: this.$store.state.user.routerAnalyseTyp,
        label_level: this.$store.state.user.labelLevel,
        aspect_type: this.$store.state.user.aspectType,
        user_id: this.$store.state.user.user_id,
        client_id: this.$store.state.user.client_id,
        sign: this.$store.state.user.sign,
        pm_id: this.$store.state.user.pm_id,
        cf_selected_type: this.$store.state.user.cf_selected_type,
        cf_word: this.$store.state.user.cf_word,
      };
    },
  },
  watch: {
    listenObj: {
      handler(newVal, oldVal) {
        if (
          JSON.stringify(newVal ? newVal : "") !==
          JSON.stringify(oldVal ? oldVal : "")
        ) {
          //   this.$router.push({
          //     name: this.$route.name,
          //     query: {
          //       plat: this.$store.state.user.plants
          //         ? this.$store.state.user.plants.join(",")
          //         : "",
          //       brand_id: this.$store.state.user.selectedType
          //         ? this.$store.state.user.selectedType.join(",")
          //         : "",
          //       start: parseTime(this.$store.state.user.startMonth, "{y}-{m}"),
          //       end: parseTime(this.$store.state.user.endMonth, "{y}-{m}"),
          //       word: this.$store.state.user.selectedKeyWords,
          //       kol_id: this.$store.state.user.KolId,
          //       kol_name: this.$store.state.user.KolName,
          //       cat_id: this.$store.state.user.catId,
          //       rule_id: this.$store.state.user.ruleId,
          //       cat_name: this.$store.state.user.catName,
          //       analyse_typ: this.$store.state.user.analyseTyp,
          //       r_rule_id: this.$store.state.user.routerRuleId,
          //       words: this.$store.state.user.words,
          //       r_analyse_typ: this.$store.state.user.routerAnalyseTyp,
          //       label_level: this.$store.state.user.labelLevel,
          //       aspect_type: this.$store.state.user.aspectType,
          //       kol_type: this.$store.state.user.kolType
          //         ? this.$store.state.user.kolType.join(",")
          //         : "",
          //     },
          //   });
        }
      },
      deep: true,
    },
  },
};
